import styled from 'styled-components';
export const DEFAULT_SPACING = '0.2rem';
export const ToggleLabel = styled.label `
  display: inline-block;
  cursor: pointer;
  position: relative;
  min-width: ${({ labelSize }) => `calc(2 * ${labelSize} + 2 * ${DEFAULT_SPACING})`};
  max-width: ${({ labelSize }) => `calc(2 * ${labelSize} + 2 * ${DEFAULT_SPACING})`};
  height: ${({ labelSize }) => `calc(${labelSize} + 2 * ${DEFAULT_SPACING})`};
`;
export const ToggleInput = styled.input `
  width: 0;
  height: 0;
`;
export const ToggleSpan = styled.span `
  position: absolute;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.borders.hover};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 2rem;
  &:before {
    position: absolute;
    content: '';
    height: ${({ labelSize }) => labelSize};
    width: ${({ labelSize }) => labelSize};
    left: ${DEFAULT_SPACING};
    top: ${DEFAULT_SPACING};
    background-color: ${({ theme }) => theme.colors.surface.default};
    -webkit-transition: 0.4s;
    transition: 0.4s all;
    border-radius: ${({ theme }) => theme.borderRadius.highest};
    box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.03), 0px 3px 8px rgba(0, 0, 0, 0.1);
  }
  &:hover {
    &:before {
      box-shadow: 0px 3px 1px rgba(0, 0, 0, 0.03),
        0px 3px 8px rgba(0, 0, 0, 0.1);
    }
  }
  ${ToggleInput}:checked + & {
    background-color: ${({ theme }) => theme.colors.interactive.brandColor};
  }
  ${ToggleInput}:checked + &:before {
    -webkit-transform: translateX(100%);
    -ms-transform: translateX(100%);
    transform: translateX(100%);
  }
`;
//# sourceMappingURL=style.js.map